// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const ImageAddIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd">
      <path
        d="M13.56 4.69c-.03-.61-.5-1.14-1.1-1.14l-3.12-.03c-1.03 0-1.98.56-2.48 1.47-.46.84-.65 1.08-.7 1.12-.25.27-.6.43-.96.44-2.04 0-3.7 1.66-3.7 3.7v5.86c0 2.63 2.14 4.78 4.78 4.78h10.16c2.64 0 4.79-2.15 4.79-4.78v-2.86c0-.56-.45-1.01-1-1.1-3.66-.61-6.48-3.78-6.67-7.46"
        opacity=".5"
      />
      <path d="M21.72 5.3h-1.41V3.9c0-.43-.35-.78-.78-.78s-.78.35-.78.78v1.4h-1.42c-.43 0-.78.34-.78.77s.35.78.78.78h1.42v1.42c0 .43.35.78.78.78s.78-.35.78-.78V6.86h1.41c.43 0 .78-.35.78-.78s-.35-.77-.78-.77M11.36 17.34c-2.2 0-3.99-1.79-3.99-3.99s1.8-3.99 4-3.99 3.98 1.8 3.98 4-1.79 3.98-3.99 3.98m-2.43-3.99c0-1.34 1.1-2.43 2.43-2.43 1.35 0 2.44 1.1 2.44 2.43 0 1.35-1.1 2.44-2.44 2.44s-2.43-1.1-2.43-2.44" />
    </g>
  </SvgIcon>
);

export default ImageAddIcon;
